import { useState } from 'react';
import { Link } from 'react-router-dom';
import './PatternMemory.css';

const PatternMemory = () => {
  const [sequence, setSequence] = useState([]);
  const [playerSequence, setPlayerSequence] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [gameActive, setGameActive] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [score, setScore] = useState(0);
  const [activeButton, setActiveButton] = useState(null);

  const colors = ['red', 'blue', 'green', 'yellow'];

  const startGame = () => {
    setGameActive(true);
    setGameOver(false);
    setScore(0);
    setSequence([]);
    setPlayerSequence([]);
    nextRound([]);
  };

  const nextRound = (currentSequence) => {
    const newColor = colors[Math.floor(Math.random() * colors.length)];
    const newSequence = [...currentSequence, newColor];
    setSequence(newSequence);
    setPlayerSequence([]);
    playSequence(newSequence);
  };

  const playSequence = async (seq) => {
    setIsPlaying(true);
    for (let i = 0; i < seq.length; i++) {
      await new Promise(resolve => setTimeout(resolve, 500));
      setActiveButton(seq[i]);
      await new Promise(resolve => setTimeout(resolve, 500));
      setActiveButton(null);
    }
    setIsPlaying(false);
  };

  const handleButtonClick = (color) => {
    if (isPlaying || !gameActive || gameOver) return;

    const newPlayerSequence = [...playerSequence, color];
    setPlayerSequence(newPlayerSequence);
    setActiveButton(color);
    setTimeout(() => setActiveButton(null), 300);

    const currentIndex = newPlayerSequence.length - 1;
    
    if (newPlayerSequence[currentIndex] !== sequence[currentIndex]) {
      setGameActive(false);
      setGameOver(true);
      return;
    }

    if (newPlayerSequence.length === sequence.length) {
      setScore(s => s + 1);
      setTimeout(() => nextRound(sequence), 1000);
    }
  };

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">🎵 Pattern Memory</h1>
        <div className="game-instructions">
          Watch the pattern and repeat it!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          Level: {score}
          {isPlaying && ' (Watch...)'}
        </div>
        
        <div className="game-play-area">
          <div className="pattern-game-area">
            <div className="pattern-grid">
              {colors.map(color => (
                <button
                  key={color}
                  className={`pattern-button ${color} ${activeButton === color ? 'active' : ''}`}
                  onClick={() => handleButtonClick(color)}
                  disabled={isPlaying || !gameActive}
                />
              ))}
            </div>

            {!gameActive && (
              <div className="game-status-overlay">
                {gameOver ? (
                  <div className="status-message lose">
                    Game Over! Level: {score}
                  </div>
                ) : (
                  <div className="status-message start">Press Start!</div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="game-controls">
          <button className="btn btn-primary" onClick={startGame}>
            {gameOver ? 'Play Again' : 'Start Game'}
          </button>
          <Link to="/" className="btn btn-secondary">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default PatternMemory;
